import React from "react";
import Map, { DrawingTools, MapConstant, MapControls } from "../../../../../lib/Map";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import appConstants from "../../../../../appConstants";
import { compose } from "recompose";
import { withTheme } from "@material-ui/core";
import { withAppConfig } from "../../../../../appConfigContext";
import Events from "../../../../../utilities/EventEmitter";
import DriverMapContent from "./DriverMapContent";

class DriverMap extends React.Component {
  constructor(props) {
    super(props);
    this.childRef = React.createRef();
  }

  onScaleDrawingComplete = (...params) => {
    this.childRef.current.onScaleDrawingComplete(...params)
  }

  hideAllPopups = () => {
    this.childRef.current.hideAllPopups();
  };

  setChildRef = (ref) => {
    this.childRef.current = ref;
  }

  render() {
    const { location: terminalLocation } =
      this.props.userData.userProfile.terminal;
    const { theme } = this.props;
    return (
      <div className={"mapViewContainer"} id="dispatchMapContainer">
        <Map
          zoom={appConstants.MAP_ZOOM_LEVEL}
          initialCenter={terminalLocation}
          center={terminalLocation}
          mapId="dispatchMap"
          mapTheme={theme.themeName}
          eventHub={this.props.glEventHub}
          onClick={this.hideAllPopups}
          trafficWeatherVisibility={true}
          mapConfig={this.props.configJSON?.maps}
        >
          <DrawingTools
            // forceRender updates the options of drawing Manager && updates the configurations of drawings already drawn on map
            // set to true when theme changes
            // forceRender={this.state.themeChanged}
            rectangleOptions={{
              fillColor: theme.MapDrawingColor,
              strokeColor: theme.MapDrawingColor,
            }}
            polylineOptions={{
              strokeColor: theme.MapDrawingColor,
            }}
            polygonOptions={{
              fillColor: theme.MapDrawingColor,
              strokeColor: theme.MapDrawingColor,
            }}
            eventHub={Events}
            onDrawingComplete={this.onScaleDrawingComplete}
          />
          <MapControls
            controlOptions={{
              zoomControl: {
                position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
              },
              satelliteViewControl: {
                position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
              },
              reCenterMapControl: {
                position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
              },
            }}
          />
          <DriverMapContent
            {...this.props}
            forwardedRef={this.setChildRef}
            key={this.props.userData.userProfile.terminal.code}
          />
        </Map>
      </div>
    );
  }
}

export default compose(withUserProfile, withTheme(), withAppConfig)(DriverMap);
